module.exports = __webpack_public_path__ + "img/screenshot-wechat.52ecad42.png";